<template>
    <div class="main">
        <div class="elder_manage_title">
            <p class="title">标准地址库</p>
        </div>
        <div class="publicMain">
            <!-- 左边卡片 -->
            <el-card class="card-l">
                <el-tree
                    :expand-on-click-node="false"
                    class="cardtree"
                    :data="data"
                    node-key="id"
                    default-expand-all
                >
                    <span class="custom-tree-node" slot-scope="{ node, data }">
                        <span>
                            <i class="party-icon"></i
                            ><span
                                class="tree-node-span"
                                @click="lookDataFun(data)"
                                >{{ data.communityName }}</span
                            ><i
                                v-if="data.communityType < 4"
                                class="el-icon-s-add"
                                @click="addDataFun(data)"
                            ></i
                            ><i
                                v-if="
                                    !data.children || data.children.length === 0
                                "
                                class="el-icon-delete"
                                @click="deletDataFun(data.id)"
                            ></i>
                        </span>
                    </span>
                </el-tree>
            </el-card>
            <!-- 右边卡片 -->
            <div class="card-rb">
                <div class="card-4">
                    <el-card :body-style="{ padding: '16px' }">
                        <el-form
                            :model="ruleForm"
                            size="small"
                            ref="ruleForm"
                            class="demo-ruleForm"
                            label-width="130px"
                        >
                            <el-row>
                                <el-col :span="11">
                                    <el-form-item
                                        label="请获取省："
                                        prop="sheng"
                                    >
                                        <el-select
                                            v-model="ruleForm.sheng"
                                            placeholder="请获取省"
                                            @change="handleProvince"
                                            style="width: 80%"
                                        >
                                            <el-option
                                                v-for="(
                                                    item, index
                                                ) in provinceList"
                                                :key="index"
                                                :label="item.name"
                                                :value="item.adcode"
                                            >
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="请获取区：" prop="qu">
                                        <el-select
                                            v-model="ruleForm.qu"
                                            placeholder="请获取区"
                                            @change="handleArea"
                                            style="width: 80%"
                                        >
                                            <el-option
                                                v-for="(
                                                    item, index
                                                ) in areaList"
                                                :key="index"
                                                :label="item.name"
                                                :value="item.adcode"
                                            >
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="11" :offset="2">
                                    <el-form-item label="请获取市：" prop="shi">
                                        <el-select
                                            v-model="ruleForm.shi"
                                            placeholder="请获取市"
                                            @change="handleCity"
                                            style="width: 80%"
                                        >
                                            <el-option
                                                v-for="(
                                                    item, index
                                                ) in cityList"
                                                :key="index"
                                                :label="item.name"
                                                :value="item.adcode"
                                            >
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item
                                        label="请获取街道："
                                        prop="jiedao"
                                    >
                                        <el-select
                                            v-model="ruleForm.jiedao"
                                            placeholder="请获取街道"
                                            style="width: 80%"
                                            @change="streetChange"
                                        >
                                            <el-option
                                                v-for="(
                                                    item, index
                                                ) in streetList"
                                                :key="index"
                                                :label="item.name"
                                                :value="item.adcode + index"
                                            >
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-form-item label="社区名称：" prop="address">
                                <el-input
                                    v-model.trim="ruleForm.address"
                                    style="
                                        margin-top: 12px;
                                        margin-bottom: 12px;
                                    "
                                    placeholder="请输入"
                                ></el-input
                            ></el-form-item>
                            <el-form-item label="位置定位：" prop="name">
                                <el-button
                                    type="danger"
                                    icon="el-icon-location-outline"
                                    @click="location"
                                    >定位到标准地址</el-button
                                >
                                <div class="box" style="margin-top: 25px">
                                    <mapbox
                                        v-if="mapshow"
                                        :orgId="ruleForm"
                                        :on-success="mapSuccess"
                                        style="width: 100%; height: 500px"
                                    ></mapbox>
                                </div>
                            </el-form-item>
                            <div class="footer">
                                <el-button
                                    type="primary"
                                    @click="submitForm('ruleForm')"
                                    >保存</el-button
                                >
                                <el-button @click="cancleForm('ruleForm')"
                                    >取消</el-button
                                >
                            </div>
                        </el-form>
                    </el-card>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import mapbox from "./components/map"
import mapLoca from "./components/mapLoca"
import AMap from "AMap" // 引入高德地图
export default {
    name: "standardAddress",
    components: {
        mapbox,
        mapLoca,
    },
    data() {
        return {
            // 树形控件的配置
            defaultProps: {
                children: "children",
                label: "label",
            },
            provinceList: [], //省列表
            cityList: [], //市列表
            streetList: [], //街道列表
            areaList: [], //区列表
            committeeList: [], //委员会
            communityList: [],
            ruleForm: {
                id: "",
                address: "",
                parentId: "",
                shengId: "",
                sheng: "",
                quId: "",
                qu: "",
                jiedaoId: "",
                jiedao: "",
                communityName: "",
                shiId: "",
                shi: "",
                latitude: "",
                longitude: "",
                areaDivision: "",
                communityType: "",
            },
            //地图显示
            mapshow: false,
            lookdata: false,
            data5: [],
            member: [],
            data: [],
        }
    },
    created() {},
    mounted() {
        this.findTreelist()
        this.getProvince()
    },

    methods: {
        // 保存
        submitForm(formName) {
            if (this.ruleForm.communityType == 0) {
                this.ruleForm.communityName = this.ruleForm.sheng
            } else if (this.ruleForm.communityType == 1) {
                this.ruleForm.communityName = this.ruleForm.shi
            } else if (this.ruleForm.communityType == 2) {
                this.ruleForm.communityName = this.ruleForm.qu
            } else if (this.ruleForm.communityType == 3) {
                this.ruleForm.communityName = this.ruleForm.jiedao
            } else {
                this.ruleForm.communityName = this.ruleForm.address
            }

            let data = this.ruleForm
            this.$http
                .request({
                    url: "/ypt/admin/standardAddress/info/save",
                    method: "POST",
                    data,
                })
                .then((res) => {
                    console.log(res, "111")
                    if (res.code == 200) {
                        this.$message.success(res.message)
                        this.findTreelist()
                        this.ruleForm = {
                            id: "",
                            address: "",
                            parentId: "",
                            shengId: "",
                            sheng: "",
                            quId: "",
                            qu: "",
                            jiedaoId: "",
                            jiedao: "",
                            communityName: "",
                            shiId: "",
                            shi: "",
                            latitude: "",
                            longitude: "",
                            areaDivision: "",
                            communityType: "",
                        }
                        this.mapshow = false
                        // this.cancleForm()
                    } else {
                        this.$message.error(res.message)
                    }
                })
        },
        // 取消
        cancleForm(formName) {
            // this.ruleForm={}
            this.$refs[formName].resetFields()
            this.mapshow = false
        },
        // 成功返回
        mapSuccess(info) {
            this.ruleForm.areaDivision = info
            console.log(info, "地图信息")
        },
        // 地图显示
        location() {
            if (this.ruleForm.shengId != null && this.ruleForm.shengId != "") {
                console.log(this.ruleForm.shengId == "", "22")
                this.mapshow = !this.mapshow
            } else {
                this.$message.warning("请先选择地址")
            }
        },
        //获取社区组织树形数据
        async findTreelist() {
            this.$http
                .request({
                    url: "/ypt/admin/standardAddress/info/StandardAddressTree",
                    method: "POST",
                    data: {},
                })
                .then((res) => {
                    this.data = res.content
                    if (res.content) {
                        this.lookdata = true
                    }
                })
        },
        // 清除数据
        cleardata() {
            this.ruleForm = {}
            this.member = []
        },
        // 添加树
        addDataFun(parmar) {
            // console.log(parmar, "999")
            let self = this
            this.ruleForm = {}
            let ruleForm = {}
            this.mapshow = false
            if (parmar.communityType == 0) {
                ruleForm.communityName = parmar.shi
                ruleForm.communityType = 1
            } else if (parmar.communityType == 1) {
                ruleForm.communityName = parmar.qu
                ruleForm.communityType = 2
            } else if (parmar.communityType == 2) {
                ruleForm.communityName = parmar.jiedao
                ruleForm.communityType = 3
            } else {
                ruleForm.communityName = parmar.shequ
                ruleForm.communityType = 4
            }
            ruleForm.parentId = parmar.id
            ruleForm.address = parmar.address
            ruleForm.shengId = parmar.shengId
            ruleForm.sheng = parmar.sheng
            ruleForm.quId = parmar.quId
            ruleForm.qu = parmar.qu
            ruleForm.jiedaoId = parmar.jiedaoId
            ruleForm.jiedao = parmar.jiedao
            ruleForm.shiId = parmar.shiId
            ruleForm.shi = parmar.shi
            ruleForm.latitude = parmar.latitude
            ruleForm.longitude = parmar.longitude
            ruleForm.areaDivision = parmar.areaDivision
            this.ruleForm = Object.assign({}, ruleForm)
            console.log(this.ruleForm, "222")
        },

        //删除树
        deletDataFun(id) {
            let data = { id: id }
            this.$confirm("确认永久删除吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                this.$http
                    .request({
                        url: "/ypt/admin/standardAddress/info/deleteById",
                        method: "POST",
                        data,
                    })
                    .then((res) => {
                        if (res.code === 200) {
                            this.cleardata()
                            this.findTreelist()
                        }
                    })
            })
        },
        //获取地址
        getDistrict(name = "中国", params = null) {
            let self = this
            return new Promise((resolve, reject) => {
                var opts = {
                    subdistrict: 1, //返回下一级行政区
                    extensions: "all",
                    showbiz: false, //最后一级返回街道信息
                }
                let district = new AMap.DistrictSearch(opts)
                let geocoder = new AMap.Geocoder({
                    city: "", //城市设为北京，默认：“全国”
                    radius: 1000, //范围，默认：500
                })
                try {
                    self.myMap.remove(self.marker)
                } catch (err) {
                    console.log(err)
                }

                self.marker = new AMap.Marker()
                district.search(name, (status, result) => {
                    if (status == "complete") {
                        resolve(result.districtList[0])
                        if (this.isMap) {
                            this.isMap = false
                            return
                        }
                        let bounds = result.districtList[0].boundaries
                        self.polygon = null
                    }
                })
            }).catch((err) => {
                console.log(err)
            })
        },
        //获取省级
        async getProvince() {
            this.provinceList = []
            this.cityList = []
            this.areaList = []
            this.streetList = []
            let province = await this.getDistrict()
            this.provinceList = province.districtList
        },
        //  省级地址选择发生改变
        async handleProvince(val) {
            this.cityList = []
            this.areaList = []
            this.streetList = []
            this.communityList = []
            this.ruleForm.shi = ""
            this.ruleForm.qu = ""
            this.ruleForm.jiedao = ""
            let city = await this.getDistrict(val)

            this.cityList = city.districtList
        },
        //市级地址发生改变
        async handleCity(val) {
            this.areaList = []
            this.streetList = []
            this.communityList = []
            this.ruleForm.qu = ""
            this.ruleForm.jiedao = ""
            let area = await this.getDistrict(val)
            console.log(area.districtList, "111")
            this.areaList = area.districtList
        },
        //县区级地址发生改变
        async handleArea(val) {
            this.streetList = []
            this.communityList = []
            this.addForm.originalStreetId = ""
            this.addForm.originalCommunityId = ""
            let street = await this.getDistrict(val)
            console.log(street.districtList, "222")
            this.streetList = street.districtList
        },
        //街道地址发生变化
        streetChange(val) {
            console.log(val, "街道")
            this.streetList.forEach((item) => {
                if (item.adcode == val) {
                    this.addForm.latitude = item.center.lat
                    this.addForm.longitude = item.center.lng
                }
            })
        },
        // 委员会
        handleCommunityChange() {},
        // 查看树
        lookDataFun(parmar) {
            let ruleForm = {}
            this.ruleForm = {}
            ruleForm.id = parmar.id
            ruleForm.parentId = parmar.parentId
            ruleForm.address = parmar.address
            ruleForm.shengId = parmar.shengId
            ruleForm.sheng = parmar.sheng
            ruleForm.quId = parmar.quId
            ruleForm.qu = parmar.qu
            ruleForm.jiedaoId = parmar.jiedaoId
            ruleForm.jiedao = parmar.jiedao
            ruleForm.communityName = parmar.communityName
            ruleForm.communityType = parmar.communityType
            ruleForm.shiId = parmar.shiId
            ruleForm.shi = parmar.shi
            ruleForm.latitude = parmar.latitude
            ruleForm.longitude = parmar.longitude
            ruleForm.areaDivision = parmar.areaDivision
            this.ruleForm = Object.assign({}, ruleForm)
        },
    },
}
</script>
<style lang="less" scoped>
.publicMain {
    display: flex;
    justify-content: space-between;
    background-color: #eef1f5;
    padding: 10px;
    box-sizing: border-box;
    width: 100%;
    height: calc(100% - 50px);

    .member-title {
        height: 30px;
        line-height: 30px;
    }

    /deep/ ::-webkit-scrollbar {
        display: block;
    }

    .el-form-item {
        margin-bottom: 25px !important;
    }

    .party-icon {
        display: inline-block;
        width: 16px;
        height: 15px;
        background-image: url("../assets/image112/icon_011.png");
    }

    // 左边树状列表卡片
    .card-l {
        width: 260px;
        height: 100%;
        overflow-x: auto;
        overflow-y: auto;
        border: none;

        .cardtree {
            overflow-x: auto;
            width: 150%;

            .el-tree-node > .el-tree-node__children {
                overflow: auto;
                background-color: transparent;
            }

            /deep/ ::-webkit-scrollbar {
                display: block;
            }
        }
    }

    // 右边卡片
    .card-rb {
        width: calc(100% - 280px);
        height: 100%;
        overflow-y: auto;
        border: none;

        .card-4 {
            border: none;
            height: 100%;

            .demo-ruleForm {
                .ruleForm_box {
                    display: flex;
                    justify-content: space-between;
                    width: 100%;
                    padding: 20px 0;

                    .ruleForm_item {
                        width: 48%;

                        .rulelable {
                            width: 100%;
                            height: 35px;
                        }

                        .ruleinput {
                            width: 100%;
                            display: flex;
                            justify-content: space-between;

                            .rulespan2 {
                                float: left;
                                width: 49%;

                                .rulespan2_input {
                                    width: 100%;
                                }
                            }
                        }
                    }

                    .ruleradio {
                        height: 75px;
                        line-height: 75px;
                    }
                }

                .ruleForm_bottom {
                    width: 100%;
                    text-align: right;
                    margin-top: 40px;
                }
            }
        }
    }

    .addressselect {
        display: flex;
        justify-content: space-between;
        margin-bottom: 15px;

        .addressselect_item {
            width: 24%;
        }
    }

    .address_xx {
        width: 100%;
        height: 320px;
        display: flex;
        justify-content: space-between;

        .add_list {
            width: 24%;
            height: 300px;
            border: 1px solid #c0c6d9;
            border-radius: 5px;
            overflow-y: auto;
        }

        .add_map {
            width: 74%;
            height: 300px;
            border: 1px solid #c0c6d9;
        }
    }

    .custom-tree-node {
        position: relative;

        .el-icon-s-icon {
            content: url(../assets/image112/icon_011.png);
            width: 15px;
            height: 15px;
            float: left;
            margin-top: 3px;
        }

        .tree-node-span {
            margin-left: 10px;
        }

        .el-icon-s-add {
            content: url(../assets/image112/metro_05.png);
            width: 15px;
            margin-left: 10px;
        }

        .el-icon-s-add:hover {
            content: url(../assets/image112/metro_03.png);
        }

        .el-icon-delete {
            content: url(../assets/image112/metro_14.png);
            width: 15px;
            margin-left: 10px;
        }

        .el-icon-delete:hover {
            content: url(../assets/image112/metro_13.png);
            // width: 12px;
            // height: 12px;
            // margin-left: 10px;
        }
    }

    .ZUZHIimg {
        position: relative;

        .threestyleimg {
            display: flex;
            flex-wrap: wrap;

            .threestyleimgtu {
                width: 100%;
                height: 70%;
                // background-color: red;
                display: flex;
                // justify-content: center;
                // align-items: center;
            }

            .threestyleimgbtnzzxz {
                input {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 463px;
                    height: 200px;
                    opacity: 0;
                    cursor: pointer;
                }
            }

            .el-icon-s-add {
                content: url(../assets/image112/metro_05.png);
                width: 15px;
                margin-left: 10px;
            }

            .el-icon-s-add:hover {
                content: url(../assets/image112/metro_03.png);
            }

            .el-icon-delete {
                content: url(../assets/image112/metro_14.png);
                width: 15px;
                margin-left: 10px;
            }

            .el-icon-delete:hover {
                content: url(../assets/image112/metro_13.png);
                // width: 12px;
                // height: 12px;
                // margin-left: 10px;
            }
        }

        .ZUZHIimg {
            position: relative;

            .threestyleimg {
                display: flex;
                flex-wrap: wrap;

                .threestyleimgtu {
                    width: 100%;
                    height: 70%;
                    // background-color: red;
                    display: flex;
                    // justify-content: center;
                    // align-items: center;
                }

                .threestyleimgbtnzzxz {
                    input {
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 463px;
                        height: 200px;
                        opacity: 0;
                        cursor: pointer;
                    }
                }
            }
        }

        .el-form-item {
            margin-bottom: 0px;
        }
    }
}
.elder_manage_title {
    position: relative;
    width: 100%;
    margin-bottom: 15px;
    &::after {
        position: absolute;
        left: 120px;
        right: 0;
        display: block;
        content: "";
        border-bottom: 1px solid #e4e7ed;
    }
    .title {
        box-sizing: border-box;
        display: inline-block;
        width: 120px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        color: #409eff;
        font-size: 14px;
        border: 1px solid #e4e7ed;
        border-bottom: none;
        border-radius: 4px 4px 0 0;
        box-sizing: border-box;
        background: #ffffff;
    }
}
.footer {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: 15px;
}
</style>